import { memberSeatInitialData } from "../types/InitialData"

export type MemberSeatTableType = {
  memberId: number
  displayName: string
  role: string
  lastActivity: string
  seatAssigned: string
  seatAutoRedemption: string
  expiresAt: number
}

const convertToMemberReport = (data: memberSeatInitialData): MemberSeatTableType[] => {

  const members = data?.members ?? []

  const memberData = members.map(member => ({
    memberId: member.memberId ?? 0,
    displayName: member.displayName ?? '',
    role: member.role ?? '',
    lastActivity: member.lastActivity ?? '',
    seatAssigned: member.seatAssigned ?? 'off',
    seatAutoRedemption: member.seatAutoRedemption ?? 'off',
    expiresAt: member.expiresAt ?? 0,
  }));

  return memberData;
  
}

export const MemberTableData = (data: memberSeatInitialData): MemberSeatTableType[] => {
  return convertToMemberReport(data)
}
